import React from "react";

function AboutPl() {
  return (
    <div>
      <div className="container ">
        <div className="aboutHeaderContainer">
          
          
          <h2 >
           <div className="aboutHeader">Witaj <span  style={{fontFamily: "Baskervville, serif", textDecoration: "lowercase" }}>w</span></div> 
            
            <div className="aboutHeader aboutTitle">projekcie Balance</div>
          </h2>
        </div>

        <div className="aboutParagraph">
          <p>
            projekcie stworzenia aplikacji, która zmieni świat. Pomysł na
            Balance zrodził się z poszukiwania odpowiedzi na pytanie, ile warte
            są nasze codzienne decyzje? Ile warte są nasze zakupy? Ile warte
            jest nowe krzesło, para spodni, gra wideo?
          </p>

          <p>
            Balance powstało podczas rozmów o konsumpcjonizmie, szacunku dla
            środowiska, a także o zwiększaniu naszej świadomości jako
            konsumentów.
          </p>

          <p>
            Celem aplikacji Balance jest nie tylko globalna zmiana świata, ale
            także zmiana życia naszej najbliższej społeczności poprzez
            zwiększanie świadomości o globalnych problemach, kwestionowanie
            naszego konsumpcjonizmu i informowanie o naszych decyzjach.
          </p>

          <p>
            Poszukujemy osób, które chcą zaangażować się w ten zmieniający życie
            projekt i mogą zaoferować swój czas, doświadczenie i wiedzę.
          </p>
          <ul>
<li>deweloperów</li>
<li>badaczy</li>
<li>socjologów</li>
<li>pracowników organizacji pozarządowych</li>
<li>specjalistów od interfejsu uytkownika</li>
</ul>
          <p>
            (więcej informacji znajdziesz na stroinie naszego repozytorium na
            platformie GitHub{" "}
            <a
              className="ainvert"
              style={{ fontSize: "1.4em" }}
              target="blank"
              href="https://github.com/DabTheMatt/balance"
            >
              tutaj
            </a>{" "}
            - strona otworzy się w nowej zakładce)
          </p>

          <p>
            Balance to prosta aplikacja, która porównuje wartość przedmiotu z
            wartością pomocy organizacji zajmujących się pomocą humanitarną, walką o prawa człowieka, 
            ochroną dziedzictwa kulturowego oraz wspieraniem inicjatyw
            oddolnych.
          </p>

          <p>
            Balance daje konsumentowi możliwość poznania organizacji i
            programów, które pomagają innym i dbają o środowisko naturalne.
          </p>

          <p>
            Projekt Balance App to projekt non-profit, jednak poszukujemy
            patronów zmian, którzy mogliby przekazać środki finansowe na rozwój
            aplikacji.
          </p>

          

          <p>
            Mamy nadzieję, że rozwój aplikacji przyniesie zmianę nie tylko w
            naszych konsumenckich nawykach, świadomości społecznej i duchu
            wspólnoty, ale także pomoże w rozwoju startupu społecznego “INSPIRO
            UP”. W przyszłości “INSPIRO UP” wesprze finansowo budowę
            niezależnego domu kultury w Polsce, gdzie INSPIRO działało przez
            wiele lat. Stworzyliśmy centrum społeczności, które było bezpieczną
            przystanią dla ludzi z różnych środowisk i które skupiało się na
            edukacji, samorozwoju, życiu towarzyskim, kulturze, sztuce i
            budowaniu społeczeństwa obywatelskiego.
          </p>

          <p>
            Marzymy o tym, by INSPIRO mogło znowu zaistnieć i wierzymy, że
            rozwój aplikacji Balance i praca nad tym projektem pomoże nam to
            marzenie spełnić.
          </p>

          <p>
            Aby urzeczywistnić naszą wizję i zbudować społeczny startup tworzący
            aplikacje zmieniające świat, nauczyliśmy się podstaw programowania.
            Teraz wprowadzamy tę wiedzę w życie.
          </p>

          <p>Zmiana jest trudna, ale wierzymy, że z Tobą stanie się możliwa.</p>

          <p>Zapraszamy do współpracy</p>

          <p>INSPIRO UP / Beata Kwiecińska / Maciej Dąbrowski</p>
          <p>
            email:{" "}
            <a
              className="ainvert"
              style={{ fontSize: "1.2em", textDecoration: "none" }}
              href="mailto:biuro@inspiro.org"
            >
              biuro@inspiro.org
            </a>
          </p>
        </div>

        <div style={{ marginBottom: "4em" }}>
          <a
            className="checkinvert"
            style={{ marginTop: "6em", fontSize: "1.5em" }}
            href="../balance/#/hellopl"
          >
            Strona główna
          </a> 
        </div>
        <p>v0.2-alpha</p>
      </div>
      
    </div>
  );
}

export default AboutPl;
